import type { CardNumberChallengeItem } from '@varo/graphql-schema-types';
import { atom } from 'jotai';

export const cardChallengesAtom = atom<CardNumberChallengeItem[]>([]);
